export default __webpack_public_path__ + "static/009-ba20cb2d977fca98ed9fc1d9c346f5ca.jpg";